import React, { Component } from 'react';
import Alert from 'react-s-alert';

import ModalStepBase from '../../ModalStepBase';

import EtapaQuestoes from './EtapaQuestoes';
import EtapaConteudo from './EtapaConteudo';
import EtapaResumo from './EtapaResumo';
import EtapaAvaliarConteudo from './EtapaAvaliarConteudo';

import * as TrilhaRequest from '../../../requests/trilha.request';
import * as CorrecaoRequest from '../../../requests/correcao.request';
import * as GamificacaoRequest from '../../../requests/gamificacao.request';
import { STATUS_QUESTAO, STAGE_TYPE, STUDY_STATUS, STUDENT_STAGE_STATUS } from '../../../const';
import ModalConfirm from '../../ModalConfirm';

class ModalEstudo extends Component {

    constructor(props) {
        super(props);

        // desabilita a exibição da etapa de resumo
        this.hasSummary = false;

        this.modalStepRef = React.createRef();

        this.state = {
            fullScreen: false,
            estudoFinalizado: false,

            loadingGeral: false,
            loadingFinalizarEstudo: false,
            modalConfirmarFinalizarEstudo: false,

            etapas: [],
            disparouRequestInicialEtapas: [],

            //Conteúdo
            loadingConteudo: false,
            conteudo: {},
            conteudoConcluido: false,

            //Questões
            loadingQuestoes: false,
            loadingFinalizarQuestoes: false,
            questoes: [],
            respostas: [],
            questoesEnviadas: false,
            modalConfirmarFinalizarQuestoes: false,
            comentarioQuestoes: "",
            idStageQuestoes: undefined,

            //Resumo
            loadingResumo: false,
            loadingEnviarResumo: false,
            resumo: "",
            resumoEnviado: false,
            modalConfirmarEnviarResumo: false,
            comentarioResumo: "",
            notaResumo: undefined,
            idStageResumo: undefined,

            //Avaliação
            comentarioAvaliacao: "",
            notaAvaliacao: 0,
        };

        this.onToggleFullscreen = this.onToggleFullscreen.bind(this);
        this.onClickTelaInteira = this.onClickTelaInteira.bind(this);
        this.onClickSairTelaInteira = this.onClickSairTelaInteira.bind(this);
        this.onChangeStep = this.onChangeStep.bind(this);
        this.onChangingStep = this.onChangingStep.bind(this);


        //Resumo
        this.onEnviarResumo = this.onEnviarResumo.bind(this);
        this.onChangeResumo = this.onChangeResumo.bind(this);
        this.onCancelarEnviarResumo = this.onCancelarEnviarResumo.bind(this);
        this.onChangeComentarioResumo = this.onChangeComentarioResumo.bind(this);
        this.onChangeNotaResumo = this.onChangeNotaResumo.bind(this);

        //Questoes
        this.onChangeRespostas = this.onChangeRespostas.bind(this);
        this.onClickConfirmarFinalizarQuestoes = this.onClickConfirmarFinalizarQuestoes.bind(this);
        this.onCancelarFinalizarQuestoes = this.onCancelarFinalizarQuestoes.bind(this);
        this.onChangeComentarioQuestoes = this.onChangeComentarioQuestoes.bind(this);

        //Estudo
        this.onClickFinalizarEstudo = this.onClickFinalizarEstudo.bind(this);
        this.onClickConfirmarFinalizarEstudo = this.onClickConfirmarFinalizarEstudo.bind(this);
        this.onClickCancelarFinalizarEstudo = this.onClickCancelarFinalizarEstudo.bind(this);

        //Avaliação
        this.onChangeNotaAvaliacao = this.onChangeNotaAvaliacao.bind(this);
        this.onChangeComentarioAvaliacao = this.onChangeComentarioAvaliacao.bind(this);
    }

    componentDidMount() {
        if (this.props.idEstudo) {
            this.popularEtapas();
        }
    }

    componentDidUpdate(prevProps) {
        // Don't forget to compare props, or you’ll cause an infinite loop
        if (this.props.idEstudo !== prevProps.idEstudo) {

            this.setState({ disparouRequestInicialEtapas: [], etapas: [], questoes: [], conteudo: {} });
            this.popularEtapas();
        }
    }

    onToggleFullscreen(value) {
        this.setState({ fullScreen: value });
    }

    onClickTelaInteira() {
        this.setState({ fullScreen: true });
    }

    onClickSairTelaInteira() {
        this.setState({ fullScreen: false });
    }

    async popularEtapas() {
        this.setState({ loadingGeral: true });

        var info = await TrilhaRequest.getInfoEstudo(this.props.idEstudo, this.props.idUserStudent);
        // console.log('info',info);

        //A api está retornando as etapas como uma string contendo um array json, por isso está sendo feita a conversão abaixo se necessário
        var etapas = [];
        if (info.stages && !Array.isArray(info.stages)) {
            try {
                etapas = JSON.parse(info.stages);
            } catch (error) {
                console.error(error)
            }
        } else {
            etapas = info.stages || [];
        }

        this.hasSummary = !!info.inHasSummary;

        if (!this.hasSummary) {
            // filtra a etapa resumo
            etapas = etapas.filter(f => f.idStageType !== STAGE_TYPE.RESUMO);
        }

        if (this.props.correcao) {
            // filtra a etapa avaliação
            etapas = etapas.filter(f => f.idStageType !== STAGE_TYPE.AVALIAR_CONTEUDO);

        }

        var estudoFinalizado = info.inStatusStudy && (info.inStatusStudy.toString() === STUDY_STATUS.REALIZADO.toString() || info.inStatusStudy.toString() === STUDY_STATUS.CORRIGIDO.toString());
        this.setState({ loadingGeral: false, etapas: etapas, estudoFinalizado: estudoFinalizado });


        this.popularEtapaConteudo();
        if (this.hasSummary) {
            this.popularEtapaResumo();
        }
        this.popularEtapaQuestoes();
    }

    async popularEtapaResumo() {

        this.setState({ loadingResumo: true });

        var etapaResumo = this.state.etapas.find(f => f.idStageType === STAGE_TYPE.RESUMO);
        var idStage = etapaResumo && etapaResumo.idStudyStage;

        var response = await TrilhaRequest.getDadosEtapaEstudo(this.props.idEstudo, etapaResumo.nuOrder, this.props.idUserStudent);
        var obj = (response && response[0]) || {};
        // console.log('obj',obj);
        var resumo = obj.txStudentAnswer || "";
        var enviado = (obj.inStatus === STUDENT_STAGE_STATUS.REALIZADO || obj.inStatus === STUDENT_STAGE_STATUS.CORRIGIDO);
        var comentario = obj.txComment || "";
        var nota = (typeof obj.nuScore !== 'undefined' && obj.nuScore !== null ? obj.nuScore : "").toString();

        this.setState({
            loadingResumo: false,
            resumo: resumo,
            resumoEnviado: enviado,
            comentarioResumo: comentario,
            notaResumo: nota,
            idStageResumo: idStage
        });
    }

    async popularEtapaConteudo() {

        this.setState({ loadingConteudo: true });

        var response = await TrilhaRequest.getDadosEtapaEstudo(this.props.idEstudo, STAGE_TYPE.CONTEUDO, this.props.idUserStudent);

        var conteudo = (response && response[0]) || {};
        var conteudoConcluido = conteudo.inStatus === 'R';
        this.setState({ loadingConteudo: false, conteudo: conteudo, conteudoConcluido: conteudoConcluido }, () => {

            //Dispara o evento de mudança do primeiro passo (Conteúdo)
            this.onChangeStep(0, undefined);
        });
    }

    async popularEtapaQuestoes() {

        this.setState({ loadingQuestoes: true });
        if(!this.props.idEstudo) {
            this.setState({
                loadingQuestoes: false,
                questoes: [],
                questoesEnviadas: false,
                comentarioQuestoes: "",
                idStageQuestoes: undefined
            });
            return;
        }

        var etapaQuestoes = this.state.etapas.find(f => f.idStageType === STAGE_TYPE.QUESTOES);
        var idStage = etapaQuestoes && etapaQuestoes.idStudyStage;

        var response = await TrilhaRequest.getDadosEtapaEstudo(this.props.idEstudo, etapaQuestoes.nuOrder, this.props.idUserStudent);
        var questoes = (response || []).map(this.mapQuestaoApiToQuestao);
        var obj = (response && response[0]) || {};
        var questoesEnviadas = (this.state.estudoFinalizado && obj.inStatus === 'R');
        var comentario = obj.txComment || "";
        // console.log('questoes',questoes)
        // console.log('questoesEnviadas',questoesEnviadas)

        this.setState({
            loadingQuestoes: false,
            questoes: questoes,
            questoesEnviadas: questoesEnviadas,
            comentarioQuestoes: comentario,
            idStageQuestoes: idStage
        });
    }

    mapQuestaoApiToQuestao(questaoAPI) {

        var fonte = `(${questaoAPI.coQuestionSource} ${questaoAPI.txYearReference}) `;

        //A api está retornando as alternativas como uma string contendo um array json, por isso está sendo feita a conversão abaixo se necessário
        var answers = [];
        if (!Array.isArray(questaoAPI.answers)) {
            try {
                answers = JSON.parse(questaoAPI.answers);
                answers = answers || [];
            } catch (error) {
                console.error(error)
            }
        } else {
            answers = questaoAPI.answers || [];
        }

        var opcoes = (answers || []).map(item => ({
            id: item.idAnswer,
            descricao: ajustarHtmlOpcao(item.txAnswer)
        }));
        var opcaoCorreta = (answers || []).find(item => item.inCorrect === true) || {};

        var questao = {
            id: questaoAPI.idQuestion,
            enunciado: fonte + questaoAPI.txQuestion,
            opcoes: opcoes,
            resposta: questaoAPI.txStudentAnswer,
            respostaCorreta: opcaoCorreta.idAnswer,
            status: STATUS_QUESTAO.QUESTAO_STATUS_EM_BRANCO
        };

        return questao;

        function ajustarHtmlOpcao(htmlOpcao) {
            //Algumas opções de questões vem com o HTMl envolvidos com a tag <p>, e isso acaba quebrando o layout atual.
            //O codigo abaixo remove essa tag <p> que envolve a opção da questão
            var result = htmlOpcao;
            if (htmlOpcao && htmlOpcao.indexOf("<p") !== -1) {
                var idx = htmlOpcao.indexOf(">");
                var idxEndTag = htmlOpcao.indexOf("</p", idx);

                result = htmlOpcao.substring(idx + 1, idxEndTag);
            }
            return result;
        }
    }

    onChangingStep(newStep, oldStep) {

        var oldEtapa = this.state.etapas[oldStep] || {};

        //Se está avançando o passo, saindo da etapa resumo, exibe a modal de confirmação se ainda não tiver enviado
        if (newStep > oldStep && oldEtapa.idStageType === STAGE_TYPE.RESUMO && !this.state.resumoEnviado) {

            this.setState({ modalConfirmarEnviarResumo: true });
            return false;
        }

        //Se está avançando o passo, saindo da etapa questões, exibe a modal de confirmação se ainda não tiver finalizado
        // if (newStep > oldStep && oldEtapa.idStageType === STAGE_TYPE.QUESTOES && !this.state.questoesEnviadas) {

        //     this.setState({ modalConfirmarFinalizarQuestoes: true });
        //     return false;
        // }
    }


    async onChangeStep(newStep, oldStep) {

        if (this.props.correcao || this.state.estudoFinalizado) {
            return;
        }

        if (this.state.etapas) {
            var etapa = this.state.etapas[newStep];
            var oldEtapa = this.state.etapas[oldStep] || {};
            if (!etapa) { return; }

            //Ao sair da etapa 1, coloca o conteúdo como concluído se ainda não estiver
            var conteudoConcluido = this.state.conteudoConcluido;
            if (oldEtapa.idStageType === STAGE_TYPE.CONTEUDO && !this.state.conteudoConcluido) {

                var etapaConteudo = this.state.etapas[oldStep];
                await TrilhaRequest.setDadosEtapaConteudo(this.props.idEstudo, etapaConteudo.idStudyStage, true);

                conteudoConcluido = true;
                this.setState({ conteudoConcluido: conteudoConcluido });
            }

            // var questoesEnviadas = this.state.questoesEnviadas;
            if (oldEtapa.idStageType === STAGE_TYPE.QUESTOES && this.state.respostas.length > 0) {
                // console.log('this.state.respostas',this.state.respostas)
                var etapaQuestao = this.state.etapas[oldStep];
                await TrilhaRequest.setDadosEtapaQuestoes(this.props.idEstudo, etapaQuestao.idStudyStage, this.state.respostas, true);

                // questoesEnviadas = true;
                // this.setState({ questoesEnviadas: questoesEnviadas });
            }

            //Dispara a request inicial apenas se ja não mandou
            var disparou = this.state.disparouRequestInicialEtapas[newStep];
            if (!disparou) {
                //Dispara a request de acordo com etapa
                if (etapa.idStageType === STAGE_TYPE.CONTEUDO && !conteudoConcluido) {

                    await TrilhaRequest.setDadosEtapaConteudo(this.props.idEstudo, etapa.idStudyStage, false);

                } else if (etapa.idStageType === STAGE_TYPE.RESUMO && !this.state.resumoEnviado) {

                    await TrilhaRequest.setDadosEtapaResumo(this.props.idEstudo, etapa.idStudyStage, undefined, false);

                } else if (etapa.idStageType === STAGE_TYPE.QUESTOES && !this.state.questoesEnviadas) {

                    await TrilhaRequest.setDadosEtapaQuestoes(this.props.idEstudo, etapa.idStudyStage, undefined, false);

                }
                //Não precisa registrar os acessos da etapa avaliar conteúdo
                // else if (etapa.idStageType === STAGE_TYPE.AVALIAR_CONTEUDO) {
                //     await TrilhaRequest.setDadosEtapaAvaliarConteudo(this.props.idEstudo, etapa.idStudyStage, undefined, undefined, false);
                // }

                //Registra que disparou a request
                var disparouRequestInicialEtapas = this.state.disparouRequestInicialEtapas;
                disparouRequestInicialEtapas[newStep] = true;
                this.setState({ disparouRequestInicialEtapas: disparouRequestInicialEtapas });
            }

            // if (etapa.idStageType === STAGE_TYPE.QUESTOES || etapa.idStageType === STAGE_TYPE.RESUMO) {
            //     this.setState(this.state)
            // }

        }
    }

    getEtapaContentFromStageType(stageType) {
        if (stageType === STAGE_TYPE.CONTEUDO) {

            return (<EtapaConteudo
                loading={this.state.loadingConteudo}
                conteudo={this.state.conteudo}
                fullScreen={this.state.fullScreen}
                onClickTelaInteira={this.onClickTelaInteira}
                onClickSairTelaInteira={this.onClickSairTelaInteira}
                estudoFinalizado={this.state.estudoFinalizado} />);

        } else if (this.hasSummary && stageType === STAGE_TYPE.RESUMO) {

            return (<EtapaResumo
                resumo={this.state.resumo}
                loading={this.state.loadingResumo}
                loadingEnviarResumo={this.state.loadingEnviarResumo}
                modalConfirmarEnviarResumo={this.state.modalConfirmarEnviarResumo}
                onCancelarEnviarResumo={this.onCancelarEnviarResumo}
                resumoEnviado={this.state.resumoEnviado}
                onEnviarResumo={this.onEnviarResumo}
                onChangeResumo={this.onChangeResumo}
                estudoFinalizado={this.state.estudoFinalizado}
                correcao={this.props.correcao}
                comentario={this.state.comentarioResumo}
                onChangeComentario={this.onChangeComentarioResumo}
                nota={this.state.notaResumo}
                onChangeNota={this.onChangeNotaResumo} />)

        } else if (stageType === STAGE_TYPE.QUESTOES) {

            return (<EtapaQuestoes
                loading={this.state.loadingQuestoes}
                questoes={this.state.questoes}
                onChangeRespostas={this.onChangeRespostas}
                modalConfirmarFinalizarQuestoes={this.state.modalConfirmarFinalizarQuestoes}
                onClickConfirmarFinalizarQuestoes={this.onClickConfirmarFinalizarQuestoes}
                onCancelarFinalizarQuestoes={this.onCancelarFinalizarQuestoes}
                loadingFinalizarQuestoes={this.state.loadingFinalizarQuestoes}
                questoesEnviadas={this.state.questoesEnviadas}
                estudoFinalizado={this.state.estudoFinalizado}
                correcao={this.props.correcao}
                comentario={this.state.comentarioQuestoes}
                onChangeComentario={this.onChangeComentarioQuestoes} />)

        } else if (stageType === STAGE_TYPE.AVALIAR_CONTEUDO) {

            return (<EtapaAvaliarConteudo
                onChangeNota={this.onChangeNotaAvaliacao}
                onChangeComentario={this.onChangeComentarioAvaliacao}
                estudoFinalizado={this.state.estudoFinalizado}
            />)
        }
    }

    onChangeComentarioQuestoes(comentario) {
        this.setState({ comentarioQuestoes: comentario });
    }

    onChangeComentarioResumo(comentario) {
        this.setState({ comentarioResumo: comentario });
    }

    onChangeNotaResumo(nota) {
        this.setState({ notaResumo: nota });
    }

    onChangeResumo(resumo) {
        this.setState({ resumo: resumo });
    }

    onCancelarEnviarResumo() {
        this.setState({ modalConfirmarEnviarResumo: false })
    }

    async onEnviarResumo() {
        this.setState({ loadingEnviarResumo: true });

        var etapa = this.state.etapas.find(item => item.idStageType === STAGE_TYPE.RESUMO);
        // console.log('etatap enviar resumo ',etapa)
        await TrilhaRequest.setDadosEtapaResumo(this.props.idEstudo, etapa.idStudyStage, this.state.resumo, true);

        this.setState({ loadingEnviarResumo: false, resumoEnviado: true, modalConfirmarEnviarResumo: false });
        this.modalStepRef.current.onClickNext();
    }

    async onChangeRespostas(respostas) {

        this.setState({ respostas: respostas });
    }

    onCancelarFinalizarQuestoes() {
        this.setState({ modalConfirmarFinalizarQuestoes: false });
    }

    async onClickConfirmarFinalizarQuestoes() {
        this.setState({ loadingFinalizarQuestoes: true });

        var etapa = this.state.etapas.find(item => item.idStageType === STAGE_TYPE.QUESTOES);
        // console.log('onClickConfirmarFinalizarQuestoes etapa ',etapa)
        // console.log('respostas etapa ',this.state.respostas)
        await TrilhaRequest.setDadosEtapaQuestoes(this.props.idEstudo, etapa.idStudyStage, this.state.respostas, true);

        this.setState({ loadingFinalizarQuestoes: false, questoesEnviadas: true, modalConfirmarFinalizarQuestoes: false });
        this.modalStepRef.current.onClickNext();
    }

    onClickFinalizarEstudo() {
        if (this.props.correcao) {
            this.salvarCorrecao();
        }
        else {
            this.setState({ modalConfirmarFinalizarEstudo: true });
        }
    }

    onClickCancelarFinalizarEstudo() {
        this.setState({ modalConfirmarFinalizarEstudo: false });
    }

    async onClickConfirmarFinalizarEstudo() {
        this.setState({ loadingFinalizarEstudo: true, modalConfirmarFinalizarEstudo: false });

        var etapa = this.state.etapas.find(item => item.idStageType === STAGE_TYPE.AVALIAR_CONTEUDO);
        // console.log('onClickConfirmarFinalizarEstudo ', etapa)
        // console.log('this.state.notaAvaliacao ', this.state.notaAvaliacao)
        await TrilhaRequest.setDadosEtapaAvaliarConteudo(this.props.idEstudo, etapa.idStudyStage, this.state.notaAvaliacao, this.state.comentarioAvaliacao, true);

        GamificacaoRequest.calcularPontuacaoUsuario()

        this.setState({ loadingFinalizarEstudo: false, estudoFinalizado: true }, () => {
            this.popularEtapaQuestoes();
        });

    }

    onChangeNotaAvaliacao(nota) {
        //  console.log("nota", nota);
        this.setState({ notaAvaliacao: nota });
    }

    onChangeComentarioAvaliacao(comentario) {
        this.setState({ comentarioAvaliacao: comentario });
    }

    async salvarCorrecao() {
        this.setState({ loadingFinalizarEstudo: true });

        try {
            //Request
            var response = await CorrecaoRequest.setCorrecao(
                this.props.idEstudo,
                this.props.idAccount,
                this.state.idStageResumo,
                this.state.comentarioResumo,
                this.state.notaResumo,
                this.state.idStageQuestoes,
                this.state.comentarioQuestoes
            );
            if(response && !response.message){
                throw new Error("Falha ao salvar a correção.");
            }

            this.setState({ loadingFinalizarEstudo: false });
            Alert.success("Correção salva com sucesso.", { position: 'bottom-right' });

            if (this.props.onCloseModal) {
                this.props.onCloseModal(true);
            }
        } catch (e) {
            console.error(e);
            Alert.error("Não foi possivel salvar a correção. Tente novamente mais tarde.", { position: 'bottom-right' });
            this.setState({ loadingFinalizarEstudo: false });
        }
    }

    render() {

        var stepsContent = (this.state.etapas || []).map(item => ({
            title: item.txStageType,
            content: this.getEtapaContentFromStageType(item.idStageType)
        }));

        return (<React.Fragment>
            <ModalStepBase {...this.props}
                ref={this.modalStepRef}
                id={this.props.idEstudo}
                loading={this.state.loadingGeral}
                fullScreen={this.state.fullScreen}
                onToggleFullscreen={this.onToggleFullscreen}
                showFullScreenButtons={true}
                stepsContent={stepsContent}
                onChangeStep={this.onChangeStep}
                onChangingStep={this.onChangingStep}
                onClickFinish={this.onClickFinalizarEstudo}
                loadingFinalizar={this.state.loadingFinalizarEstudo}
                esconderFinalizar={this.props.correcao ? false : this.state.estudoFinalizado} />

            <ModalConfirm isOpen={this.state.modalConfirmarFinalizarEstudo}
                style={{ width: "420px", marginTop: "40px" }}
                title="Tem certeza que deseja avaliar e finalizar este estudo?"
                content={<div>
                    <p>Ao responder a avaliação você estará finalizado este estudo.</p>
                </div>}
                confirmText="Sim, quero finalizar o estudo."
                confirmLoadingText="Finalizando, por favor aguarde..."
                onClickConfirm={this.onClickConfirmarFinalizarEstudo}
                cancelText="Não, ainda preciso de mais tempo"
                onClickCancel={this.onClickCancelarFinalizarEstudo}
            />
        </React.Fragment>
        );
    }
}

export default ModalEstudo;